import { Box, Button, MenuItem, Select, TextField } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Header from "../../../../components/Header";

import Swal from "sweetalert2";
import {
  executeDynamicSubmit,
  fetchJsonDynamic,
} from "../../../../data/DynamicServiceNew/jsondynamicservice";
import { setupManagementUrl } from "../../../../config";
import { useEffect, useState } from "react";

const setup_url = setupManagementUrl.uri;

const CollateralTypeForm = (props) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const initialValues = {
    name: props.data ? props.data.Type : "",
    subclassId: props.data ? props.data.Subclassid : "",
  };

  const validationSchema = yup.object().shape({
    name: yup.string().required("Collateral Type required"),
    subclassId: props.data ? props.data.Classid : "",
  });

  useEffect(() => {
    async function fetchAllData() {
      try {
        const rightsResponse = await fetchJsonDynamic(
          "collateralSubclasses",
          null,
          null,
          setupManagementUrl.uri
        );

        if (rightsResponse?.results) {
          const results = JSON.parse(rightsResponse?.results);
          setData(results || []);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchAllData();
  }, []);
  const handleSubmit = async (values, { setSubmitting }) => {
    const { name, subclassId } = values;
    const variables = props.isEditing
      ? { id: props.data.Id, type: name, subclassid: subclassId }
      : { type: name, subclassid: subclassId };

    await executeDynamicSubmit({
      mutationName: props.isEditing ? "updateCollateralTypes" : "createCollateralTypes",
      variables,
      mutationObjectName: "result",
      baseUrl: setup_url,
      isEditing: props.isEditing,
      entityName: "Collateral Type",
      onSuccess: () => {
        props.onClose();
        props.onAction();
      },
      setSubmitting,
    });
  };

  return (
    <Box m="20px">
      <Header
        title={
          props.isEditing ? "Edit Collateral Type" : "Create Collateral Type"
        }
        subtitle={
          props.isEditing
            ? "Edit an Existing Collateral Type"
            : "Create a New Collateral Subclass"
        }
      />
      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box display="grid" gap="30px" gridTemplateColumns="1fr 1fr">
              <TextField
                variant="filled"
                type="text"
                label="Collateral Type *"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.name}
                name="name"
                error={touched.name && !!errors.name}
                helperText={touched.name && errors.name}
                // sx={{ gridColumn: "span 2" }}
              />
              <Select
                variant="filled"
                value={values.subclassId}
                name="subclassId"
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.subclassId && !!errors.subclassId}
                displayEmpty
              >
                <MenuItem value="" disabled>
                  Select Collateral Classes
                </MenuItem>
                {data.map((roleGroup) => (
                  <MenuItem key={roleGroup.Id} value={roleGroup.Id}>
                    {roleGroup.Name}
                  </MenuItem>
                ))}
              </Select>
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                color="primary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default CollateralTypeForm;
